const defaultOptions = {
  primaryColor: '',
  speed: '1s',
  spaceBetween: '0',
  marginLeft: '0',
  right: false
}

export default defaultOptions



// WEBPACK FOOTER //
// ./lib/config.js